"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewPage = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions/useSelfActions"));
const useOpDefinitionFindWithQuestionSetsById_1 = __importDefault(require("@opsbase/react-gql-hooks/opdefinition/useOpDefinitionFindWithQuestionSetsById"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const useParams_1 = __importDefault(require("@opsbase/web-nav/useParams"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const react_1 = __importStar(require("react"));
const FedController_1 = __importDefault(require("../FedController"));
const Preview_1 = __importDefault(require("./Preview"));
exports.PreviewPage = react_1.default.memo(() => {
    const { id } = (0, useParams_1.default)();
    const { language } = (0, useSysLang_1.default)();
    const { setLanguage } = (0, useSelfActions_1.default)();
    const { loading, data: opDef } = (0, useOpDefinitionFindWithQuestionSetsById_1.default)({ variables: { id } });
    const [title] = (0, useAltForSelfLang_1.default)(opDef === null || opDef === void 0 ? void 0 : opDef.title, opDef === null || opDef === void 0 ? void 0 : opDef.titleAlt);
    (0, react_1.useEffect)(() => {
        setLanguage(language);
    }, [language, setLanguage]);
    return (react_1.default.createElement(Spinner_1.default, { busy: loading }, () => (react_1.default.createElement(Dialog_1.default, { closable: false, sysLangPicker: true, open: true, size: DialogSize_1.default.X800_YFULL, white: true, scroll: false, padded: false, title: lib_i18n_1.default.t('preview') },
        react_1.default.createElement(FedController_1.default, { mode: "edit", id: opDef === null || opDef === void 0 ? void 0 : opDef.id, title: title, form: opDef === null || opDef === void 0 ? void 0 : opDef.form, isScoreEnabled: opDef === null || opDef === void 0 ? void 0 : opDef.isScoreEnabled, isScorePublic: opDef === null || opDef === void 0 ? void 0 : opDef.isScorePublic, isGradingPublic: opDef === null || opDef === void 0 ? void 0 : opDef.isGradingPublic, allowIssuesAndNotes: opDef === null || opDef === void 0 ? void 0 : opDef.allowIssuesAndNotes, gradingMethod: opDef === null || opDef === void 0 ? void 0 : opDef.gradingMethod },
            react_1.default.createElement(Preview_1.default, null))))));
});
exports.default = exports.PreviewPage;
